import './switcher.css'
import './web_component'
import React from 'react'
import { SwitcherLayoutProps } from './types'

export const Switcher: React.FC<SwitcherLayoutProps> = ({ children, ...props }) => (
  <switcher-l {...props}>{children}</switcher-l>
)
